angular.module('ATMGurus', [
	"ATMGApi",
	"ATMGurusLogin",
	"ATMGCheckout",
	"ATMGCart",
	"ngStorage",
	"ATMGAuth",
	"ATMGUser",
	"ngAnimate",
	"P3in",
	"ui.router",
	"ui.router.state.events",
	"ui.mask",
	"angular-once",
	"socket.io",
	"angular-google-analytics"
])

/**-----------------------------------------
*
*	Routing
*
--------------------------------------------*/

.config( [
	"$locationProvider",
	"$httpProvider",
	"$stateProvider",
	"ATMGConf",
	"$compileProvider",
	"$socketProvider",
	"AnalyticsProvider",
	function( $locationProvider, $httpProvider, $stateProvider, Conf, $compileProvider, $socketProvider, AnalyticsProvider ) {

		/**-----------------------------------------------------------
		*
		*	GAnalytics setup
		*
		----------------------------------------------------------------*/

		//AnalyticsProvider.setAccount( 'UA-11997174-1' );
		AnalyticsProvider.setAccount( 'G-PY7E7ZHC3P' );
		AnalyticsProvider.trackPages( true );
		// AnalyticsProvider.setDomainName( 'atmgurus.com' );
		// AnalyticsProvider.setDomainName( 'none' );

		// $socketProvider.setConnectionUrl('https://www.atmgurus.com:8080');
		$socketProvider.setConnectionUrl(location.protocol+'//'+location.hostname+':8080' );

		// Production Tweak
		$compileProvider.debugInfoEnabled( true );

		/**
		*	Products resolver
		*/
		productsResolver.$inject = [ "Api.Store", "FilterService", "$rootScope", "$location", "Loader" ];

		function productsResolver( Store, Filters, $rootScope, $location, Loader ) {

			// we need to cold reload if it's CWI order
			var forceReload = false;
			//Loader.show();
			$rootScope.$emit( 'meta.refreshed', { page_title: "ATMGurus Store", description: "ATMGurus Store" } );
			var context = Store.switchContext( $location.path().slice(1) );
			var fromUrl = Filters.getFromUrl( context.filterName );
			Filters.filters[ context.filterName ] = fromUrl;
			if (fromUrl.where.sell_condition === "CWI") {
				forceReload = true;
			}
			//var waitTime = 0;
			//console.log("Init wait to 0ms.");
                        //if (typeof fromUrl.search === "undefined" || fromUrl.search.length < 1) {
                        //        if (fromUrl.where.product_type === "PARTS") {
                        //                //console.log("Set wait to 8500ms.");
                        //                waitTime = 8500;
                        //        } else if (fromUrl.where.product_type === "UNITS") {
                        //                //console.log("Set wait to 750ms.");
                        //                waitTime = 750;
                        //        } else {
                        //                //console.log("Set wait to 500ms.");
                        //                waitTime = 500;
                        //        }
                        //}
			//return Store.getProducts(fromUrl, forceReload)
			//	.then(() => setTimeout(function(){ Loader.hide(); }, waitTime))
			return Store.getProducts(fromUrl, forceReload);
		}

		/**
		*	Categories resolver
		*/
		categoriesResolver.$inject = ["Api.Store", "$location", "FilterService", "Loader"]

		function categoriesResolver(Store, $location, Filters, Loader) {
			Loader.show();
			var forceReload = false;
			var context = Store.getContext();
			Filters.filters[context.filterName] = Filters.getFromUrl(context.filterName);
			if (Filters.filters[context.filterName].where.sell_condition === 'CWI') {
				forceReload = true;
			}
			return Store.getCategories(Filters.filters[context.filterName], forceReload, Loader);
		}

		/**
		*	Categories resolver
		*/
		paginationResolver.$inject = ["Api.Store", "$location", "FilterService", "Loader"]

		function paginationResolver(Store, $location, Filters, Loader) {

			var context = Store.getContext();

			Filters.filters[ context.filterName ] = Filters.getFromUrl( context.filterName );
			return Store.getPagination( Filters.filters[ context.filterName ])
		}

		$stateProvider
			/**
			*	Overrides
			*/
			.state('main', {
				url: "/",
				template:  require('../templates/home.html'),
				resolve: {
					loadContent: ["ContentService", function( ContentService ) {
						return ContentService.load("")
					}]
				},
				controller: ["loadContent", function( loadContent ) {
					this.Content = loadContent
				}],
				controllerAs: "HomeCtrl",
			})

			.state('store', {
				abstract: true,
				resolve: {
					products: productsResolver,
					pagination: paginationResolver,
					categories: categoriesResolver
				},
				controller: "StoreController",
				controllerAs: "StoreCtrl",
				template: require('Templates/products.html')
			})

				.state('store.products', {url: '/products'})
				.state('store.repairs', {url: '/repairs-and-services'})
				.state( 'product-detail' , {
					url: "/product-detail/:productSlug",
					// templateUrl: "/templates/product-detail.html",
					templateProvider: function($templateCache) {
						return $templateCache.get('product-detail');
					},
					controller: "SingleProductController",
					controllerAs: "ProductCtrl",
					resolve: {
						fetchProduct: ["$q", "Loader", "$stateParams", "$location", "$rootScope", "Api.Store", function( $q, Loader, $stateParams, $location, $rootScope, Store ) {
							Loader.show()
							return new Promise((resolve, reject) => {
								return Store.getProduct($stateParams.productSlug)
									.then(response => {
										$rootScope.$emit('meta.refreshed', {
											page_title: "ATMGurus" + response.title,
											description: response.title + ' product type: ' + response.product_type + ' models: ' + response.models + ' sell_condition: ' + response.sell_condition
										})
										Loader.hide()
										return resolve(response)
									})
									.catch(reason => {
										// $location.path("/products")
									})
							})
						}]
					}
				})

			.state('schedule', {
				url: "/training/guru-u-class-schedule",
				template: "<ui-view/>",
				abstract: true
			})
				.state( 'schedule.registration', {
					url: "/schedule-registration",
					template: require('Templates/forms/class-registration.html'),
					controller: "TrainingController as TrainingCtrl"
				})

			.state( "checkout" , {
				url: "/checkout/{cartId}",
				params: {cartId: undefined},
				template: require('Templates/checkout.pug'),
				controller: "CheckoutController",
				controllerAs: "CheckoutCtrl",
				onExit: function(Cart) {
					Cart.fullyInit = false;
				}
			})

			.state( 'confirmation', {
				url: "/confirmation/{cartId}",
				template: require('Templates/checkout/confirmation.html'),
				controller: "ConfirmationController",
				controllerAs:  "ConfirmationCtrl",
				onExit: function(Cart) {
					Cart.reset();
				}
			})

			/**
			*
			*	My Account
			*
			*
			*/
			.state("myaccount", {
				url: "/my-account",
				abstract: true,
				template: require('Templates/my-account.html'),
				controllerAs: 'MyAccountRootCtrl',
				controller: function($rootScope) {
					this.currentPage = 'Home';

					$rootScope.$on('$stateChangeStart',
						function(event, toState, toParams, fromState, fromParams){
							if ('myaccount.index' == toState.name) {
								this.currentPage = "Home";
							}
						}.bind(this))
				}
			})

				.state("myaccount.index", {
					url: "",
					views: {
						'subview': {
							template: require('Templates/my-account/my-account-index.html'),
							controller: ["User", "Auth", "ErrorService", function(User, Auth, Errors) {
								this.User = User.getUserData();
								this.Errors = Errors

								this.status = {
									message: '',
									error: '',
									errorDetails: []
								}
								/**
								*	Reset Password
								*/
								this.resetPassword = function() {
									var parms = {
										first_name: this.User.userDetails.first_name,
										last_name: this.User.userDetails.last_name,
										phone: this.User.userDetails.phone,
										// token: _this.token || undefined,
										email: this.User.userDetails.email || undefined,
										password: this.User.userDetails.password,
										password_confirmation: this.User.userDetails.password_confirmation,
										current_password: this.User.userDetails.current_password
									}

									return Auth.resetPassword(parms)
										.then(response => {
											this.status = {
												message: 'Succesfully updated',
												error: false,
												errorDetails: undefined,
											}
										})
										.catch(response => {
											this.status = {
												message: 'Error',
												error: true,
												errorDetails: response.error,
											}
										})
									}
							} ],
							controllerAs: "AccountCtrl",
						}
					}
				} )

				.state("myaccount.pwdreset", {
					url: "/password-reset",
					views: {
						'subview': {
							template: require("Templates/my-account/password-reset.html"),
							controller: "RegisterController as Reset"
						}
					}
				})

					.state("myaccount.subpage", {
						url: "/:page",
						resolve: {
							dataProvider: ['MyAccountService', '$stateParams', 'Loader', 'ApiCustomer', function(MyAccountService, $stateParams, Loader, User) {
								return new Promise((resolve, reject) => {
									var page = $stateParams.page;
									Loader.show();
									User.fetchUserData()
										.then(response => {
											let user = response.data.data
											let queryString = `?id=${user.id}&email=${user.email}&customer_number=${user.current_customer.id}`
											let queryStringObj = {id: user.id, email: user.email, customer_number: user.current_customer.id} 
											return MyAccountService.getItem(page)
												.then(data => {
													data.queryString = queryString
													data.queryStringObj = queryStringObj
													Loader.hide();
													resolve(data)
												})
										})
										.catch(response => {
										})
								})
							}],
							details: ["MyAccountService", "$stateParams", "ApiQuery", "Loader",
								function(MyAccountService,  $stateParams, ApiQuery, Loader) {
									var item = undefined;
									switch ($stateParams.page) {
										case "invoices":
											item = "invoice-aging";
											break;
									}
									if (!_.isUndefined(item) ) {
										return MyAccountService.getItem(item)
											.then(function(data) {
												return data.content
											})
									}
							}],

						},
						views: {
							'additional_info': {
								template: require('Templates/bits/myaccount_additional_header.html'),
								controllerAs: "AddInfoCtrl",
								controller: ["details", "$stateParams", function(details, $stateParams) {
									this.data = {};
									// Title in case we are showing additional informations
									switch ( $stateParams.page ) {
										case "invoices":
											this.data.title =  "Invoices Aging";
											break;
										case "orders":
											break;
										case "saved-carts":
											break;
									}
									this.data.items = details;
								}],
							},
							'subview': {
								templateProvider: ["$stateParams", function($stateParams) {
									return new Promise((resolve, reject) => {
										let template = undefined
										// override for address-book
										if ($stateParams.page === "address-book" ) {
											template = require("Templates/my-account/address-book.html")
										} else {
											template = require("Templates/my-account/my-account-sub.html")
										}
										return resolve(template)
									})
								}],
								controller: "AccountController",
								controllerAs: "AccountCtrl"
							}
						},
					})

						.state("myaccount.subpage.details", {
							url: "/:item",
							resolve: {
								detailsData: ["ApiQuery", "$stateParams", "Loader", "Cart", "Checkout",
									function(ApiQuery, $stateParams, Loader, Cart, Checkout) {
										var cart = Cart;
										var checkout = Checkout;
										// setTimeout(function() {
											Loader.show();
										// }, 400)
										if ($stateParams.page === 'orders') { // || $stateParams.page === 'repairs') {
											Loader.hide();
											//console.log('atmgurus page = ' + $stateParams.page);
											return [];
										} else {
											// this means we are in saved-carts, so just load the cart
											return cart.init($stateParams.item)
												.then(function resolvedCartInit() {
													Loader.hide();
													return checkout.init(cart);
												})
										}
									}
								]
							},

							views: {
								'additional_info@myaccount': {
									template: require('Templates/checkout/confirmation.html'),
									controller: 'AccountDetailsController',
									// ConfirmationCtrl because we are using the same confirmation template
									// @TODO this would be probably better if replaced with a directive that displays line items
									controllerAs: "ConfirmationCtrl",
								},

								'subview@myaccount': {
									template: "" 		// just keep this empty
								}
							}
						})

			/**
			*	User Actions
			*/
			.state( 'login', {
				url: "/login?urlback",
				template: require('Templates/user/login.pug'),
				reloadOnSearch: true,
				controller: "LoginController",
				controllerAs: "Login",
			} )

			.state( 'reset', {
				url: "/login/reset/{token}",
				template: require('Templates/user/reset.html'),
				controller: "RegisterController",
				controllerAs: "Reset"
			} )

			.state( 'logout', {
				url: '/logout',
				controller: [ "$state", 'Auth', 'Loader', function( $state, Auth, Loader ) {
					Loader.show();
					Auth.logout()
						.then( function() {
							Loader.hide()
							$state.go("main")
						})
						.catch(() => {
							$state.go('main')
							Loader.hide()
						})
				} ]
			})

			.state( 'error_404', {
				url: "/404",
				template: require('Templates/404.html')
			})

			.state( 'maintenance', {
				url: "/503",
				template: require('Templates/503.html'),
			})

			.state( 'userActions', {
				url: "",
				abstract: true,
				template: require('Templates/user/user-actions-index.html'),
				controller: "RegisterController",
				controllerAs: "Register"
			} )

				.state('userActions.register', {
					url: "/register",
					template: require("Templates/user/register.html"),
				})

				.state('userActions.forgot', {
					url: "/forgot",
					template: require('Templates/user/forgot.html')
				})

			/**
			*
			*	Error Lookup
			*
			*
			*/
			.state("error Code Lookup", {
				url: "/error-code-lookup",
				resolve: {
					content: [
						"ContentService",
						function( ContentService ) {
						return ContentService.load( "error-code-lookup" )
							.then( function( data ) {
								return data
							})
						}]
				},
				template: require("Templates/error-code-lookup.html"),
				controller: [ "LookupService", "$scope", "content", "$sce", function( LookupService, $scope, content, $sce ) {
					$scope.Lookup = LookupService;
					$scope.Lookup.endpoint = 'error-code-lookup'
					$scope.Content = content.data

					$scope.trust = function( html ) {
						return $sce.trustAsHtml( html )
					}
				}]
			})

			/**
			*
			*	Wararnty Lookup
			*
			*
			*/
			.state("Warranty Lookup", {
				url: "/warranty-lookup",
				resolve: {
					content: [
						"ContentService",
						function( ContentService ) {
						return ContentService.load( "warranty-lookup" )
							.then(function(data) {
								return data
							})
						}]
				},
				template: require("Templates/warranty-lookup.html"),
				controller: function(LookupService, $scope, content, $sce) {
					$scope.Lookup = LookupService;
					$scope.Content = content.data

					$scope.Lookup.endpoint = 'warranty-lookup'

					$scope.trust = function( html ) {
						return $sce.trustAsHtml( html )
					}
				}
			})

			/**
			*
			*	Manuals
			*
			*
			*/
			.state("triton_management_functions", {
				url: "/training/triton-management-functions",
				resolve: {
					content: function(){
						return "/triton-management-functions-3-2-flow";
					},
				},
				template: require("Templates/iframed-content.html"),
				controller: ["$scope", "content", function( $scope, content ){
					$scope.iframe_breadcrumb_parent = 'Training';
					$scope.iframe_content = content;
					$scope.iframe_title = "Triton Management Functions";
				}]
			})

			/**
			*
			*	Multi-Brand Error Codes Lookup
			*
			*
			*/
			.state("multibrand_error_code_lookup", {
				url: "/training/multibrand-error-code-lookup",
				resolve: {
					content: [
						"ContentService",
						function( ContentService ) {
						return ContentService.load( "error-code-lookup" )
							.then( function( data ) {
								return data
							})
						}]
				},
				template: require("Templates/error-code-lookup.html"),
				controller: [ "LookupService", "$scope", "content", "$sce", function( LookupService, $scope, content, $sce ) {
					$scope.Lookup = LookupService;
					$scope.Lookup.endpoint = 'error-code-lookup'
					$scope.Content = content.data

					$scope.trust = function( html ) {
						return $sce.trustAsHtml( html )
					}
				}]
			})

			/**
			*
			*	Catch All
			*
			*/
			.state("catchAll", {
				url: "/{page:.*}",
				resolve: {
					loadContent: [
						"ContentService",
						"$stateParams",
						"$state",
						function( ContentService, $stateParams, $state ) {
							return ContentService.load( $stateParams.page )
								.then( function( data ) {
									return data
								}, function(reason) {
									$state.go('error_404')
								})
						}]
				},
				controller: ["loadContent", "$sce", function( loadContent, $sce ) {
					this.Content  = loadContent
					this.nav = loadContent.nav;

					/* trust html content */
					this.trust = function( html ) {
						return $sce.trustAsHtml( html )
					}

				}],
				controllerAs: "Content",
				templateProvider:  [
					"$stateParams",
					"ContentService",
					"$http",
					"$state",
					function( $stateParams, ContentService, $http, $state ) {

						return ContentService.load($stateParams.page)
							.then(function(response) {
								var Content = response.data;
								return Conf.templates[response.template]
							})
							// we have no interest on responding to a 404 as we're doing it in the catchAll resolver itself
						}]
				})

			$locationProvider.html5Mode( true );
	}

])

.run([
	"Auth",
	"User",
	"$rootScope",
	"Navigation",
	"Loader",
	"$location",
	"$state",
	"FilterService",
	"$templateCache",
	"$http",
	"Analytics",
	function(Auth,  User, $rootScope, Navigation, Loader, $location, $state, FilterService, $templateCache, $http, Analytics) {
		$templateCache.put('product-detail', require('Templates/product-detail.html'))
		Auth.isLogged()
			.then(response =>  {
				Navigation.fetchMenus()
				User.init()
					.catch(() => {
						console.log('FUKKO')
					})
			})
			.catch(e => {
				Navigation.fetchMenus()
			})
		// @TODO DEBUG catch state chage errors
		$rootScope.$on("$stateChangeError", console.log.bind(console));

		$rootScope.$on("$stateChangeStart", function( event, toState, toParams, fromState, fromParams ) {

			var loginRegEx = new RegExp( /^\/login\/$/ ),
				htmlPage = new RegExp( /\.html$/ ),
				searchString = $location.search();

			if (angular.isDefined(toParams.page) && htmlPage.test(toParams.page)) {
				event.preventDefault();
				window.open( toParams.page, "_blank")
				window.location.href = "/";
			}

			/**
			*
			*	UrlBack
			*	the url the user will be redirected to after login
			*	depends on where he was trying to go
			*/
			if( loginRegEx.test( toState.url ) && ! angular.isDefined( toParams.urlback ) ) {
				var urlback;
				switch ( fromState.url ) {
					case "/{page:.*}":
						urlback = fromParams.page
						break;
					case "/product-detail/:productSlug":
						urlback = "/product-detail/" + fromParams.productSlug
						break;
					default:
						urlback = fromState.url
				}
				if ( urlback !== "/register") {
					$location.search( { urlback: urlback } )
				}
			}

			if ( /accessories/.test( toParams.page ) ) {
				var filters = FilterService.get( "products" );
				filters.take = 12;
				filters.page = 1;
				filters.search = "";
				filters.orderBy = { "title": "ASC" };
				filters.where = {};
			}

			if ( angular.isDefined( searchString.brand ) || angular.isDefined( searchString.sell_condition ) ) {
				FilterService.filters.products = {
					take: 12,
					page: 1,
					orderBy: { "title": "ASC" },
					where: {},
					search: "",
				};
			}

			/**
			*	Pages for which the user needs to be authenticated
			*/
			if (/checkout/.test(toState.name)) {
				Auth.isLogged()
					.then(response => {})
					.catch(response => {
						console.log(response)
						event.preventDefault()
						var url = 'login?urlback=/checkout/'
						if (toParams.cartId) {
							url += toParams.cartId
						}
						$location.url(url)
					})
			}

			if (/myaccount/.test(toState.name)) {
				var triedUrl = "/my-account"
				if (toState.url === "/password-reset") triedUrl += "/password-reset";
				_.forEach(toParams, function(param, key, params)  {
					if (param !== null) {
						triedUrl += "/" + param
					}
				})
				Auth.isLogged()
					.then(response => {})
					.catch(resonse => {
						var url = 'login?urlback=' + encodeURIComponent(triedUrl)
						$location.url(url)
					})
			}
		})

		$rootScope.$on( "$stateChangeSuccess",  function( ) {
			Analytics._logs
			window.scrollTo(0, 0);
		})
	}
])


// using a IIF here, as we're able to to more "complicated" (useful) abstactions later on, instead
// of resorting to pure key: val params
.constant("ATMGConf", require('./config.js'))



// WEBPACK FOOTER //
// ./src/app/ATMGurus.js